const prefix = "NOTICE_";

export const EXPORT = prefix + "EXPORT";
export const GET_TIMELINE = prefix + "GET_TIMELINE";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const PREVIEW_RESEND = prefix + "PREVIEW_RESEND";
export const PREVIEW_SEND = prefix + "PREVIEW_SEND";
export const RESEND = prefix + "RESEND";
export const VIEW = prefix + "VIEW";
